'use client';

import { ReactNode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider as WagmiProviderBase } from 'wagmi';

import { createWagmiConfig } from '@/lib/wagmi';

// Create singleton instances to prevent multiple initializations
const queryClient = new QueryClient();
const wagmiConfig = createWagmiConfig();

interface I_WagmiProviderProps {
  children: ReactNode;
}

export function WagmiProvider({ children }: I_WagmiProviderProps) {
  return (
    <WagmiProviderBase config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProviderBase>
  );
}
